"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailEmitterContext = exports.PlayerEventEmitterContext = void 0;
const react_1 = __importDefault(require("react"));
exports.PlayerEventEmitterContext = react_1.default.createContext(undefined);
exports.ThumbnailEmitterContext = react_1.default.createContext(undefined);
